import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
//import { useCookies } from 'react-cookie';
import cookie from 'react-cookies';
import { isUserLoggedIn } from './../../service/action/audio-track-action';
import { AudioToTrack } from './../index';
import Header from './components/Header';
import {
  Report,
  QADashBoard,
  SADashboard,
  SuperQADashBoard,
  CreatorTeamDashboard,
  AuditKeywordTeam,
} from './../index';
class Landing extends React.Component {
  render() {
    const {
      userLogin: { loggedUser },
      page,
    } = this.props;
    //console.log(loggedUser)
    return (
      <div className='right-section'>
        <Header page={page} />
        {/* {loggedUser && loggedUser.userType && loggedUser.userType === '0' ? (
          <Report />
        ) : loggedUser.userType === '1' ? (
          <dv>
            <AudioToTrack /> <CreatorTeamDashboard />
          </dv>
        ) : loggedUser.userType === '2' || loggedUser.userType === '3' ? (
          <QADashBoard />
        ) : loggedUser.userType === '5' || loggedUser.userType === '6' ? (
          <SuperQADashBoard />
        ) : loggedUser.userType === '4' ? (
          <SADashboard />
        ) : loggedUser.userType == '7' ? (
          <dv>
            <AudioToTrack /> <CreatorTeamDashboard />
          </dv>
        ) : loggedUser.userType == '8' ? (
          <AuditKeywordTeam />
        ) : (
          <p>Loading ....!</p>
        )} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log(state)
  const { AudioToTrackReducer, userLogin, page } = state;
  return {
    AudioToTrackReducer,
    userLogin,
    page,
  };
};

export default withRouter(connect(mapStateToProps, {})(Landing));
